module.exports = __webpack_public_path__ + "img/microphone.746764e0.svg";